import { render, staticRenderFns } from "./SelectGrid.vue?vue&type=template&id=528e82bb&scoped=true&"
import script from "./SelectGrid.vue?vue&type=script&lang=js&"
export * from "./SelectGrid.vue?vue&type=script&lang=js&"
import style0 from "./SelectGrid.vue?vue&type=style&index=0&id=528e82bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528e82bb",
  null
  
)

export default component.exports